import { initialWeekStartsOn, User } from '@griply/types';

export const getWeekStartsOn = (user?: User | null) =>
  user?.settings?.startOfWeek ?? initialWeekStartsOn;
